import { render, staticRenderFns } from "./FiltersWrapper.vue?vue&type=template&id=4af8a64d"
import script from "./FiltersWrapper.vue?vue&type=script&lang=js"
export * from "./FiltersWrapper.vue?vue&type=script&lang=js"
import style0 from "./FiltersWrapper.vue?vue&type=style&index=0&id=4af8a64d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports